"use client";

import clsx from "clsx";
import { formatEmbedUnits } from "./chatAnalyticsEmbedUi";

type ChatEmbedFooterProps = {
  as_at?: string;
  units?: string | Record<string, string>;
  density?: "default" | "toolDetail";
};

/** Subtle as-at / units only — omits API paths and external Open links. */
export function ChatEmbedFooter({ as_at, units, density = "default" }: ChatEmbedFooterProps) {
  const unitsLabel = formatEmbedUnits(units);
  if (!as_at && !unitsLabel) return null;

  const compact = density === "toolDetail";

  if (compact) {
    return (
      <div
        className="mt-2 flex items-baseline justify-between gap-2 text-[9px] leading-tight text-slate-500/90 dark:text-slate-500"
        data-testid="chat-embed-footer"
      >
        {as_at ? <span className="shrink-0">As at {as_at}</span> : null}
        {unitsLabel ? (
          <span
            className={clsx(
              "min-w-0 truncate text-right text-slate-400 dark:text-slate-500",
              !as_at && "ml-auto",
            )}
          >
            {unitsLabel}
          </span>
        ) : null}
      </div>
    );
  }

  return (
    <div
      className="mt-2 border-t border-slate-200/60 pt-2 text-[11px] leading-snug text-slate-500 dark:border-slate-700/50 dark:text-slate-400"
      data-testid="chat-embed-footer"
    >
      {as_at ? <span>As at {as_at}</span> : null}
      {unitsLabel ? (
        <span className={as_at ? "ml-2 text-slate-400 dark:text-slate-500" : undefined}>{unitsLabel}</span>
      ) : null}
    </div>
  );
}
